module.exports = __webpack_public_path__ + "img/trade.b3627316.svg";